export default __webpack_public_path__ + "static/media/cfo-leadership-summi-in-riyadh.56c029ae.jpg";